import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelectedStation } from '../hooks/useSelectedStation';
import { useStations } from '../hooks/useStationAssets';

export const StationSelector = () => {
  const { t } = useTranslation();
  const { selectedStationId, setSelectedStationId, availableStations, stationLocked } =
    useSelectedStation();
  const { isLoading } = useStations();

  return (
    <label
      className="flex min-w-0 items-center gap-2 rounded-md border border-line bg-white px-2 py-1.5"
      htmlFor="global-station-selector"
    >
      <Building2 className="h-4 w-4 text-brand-600" aria-hidden="true" />
      <span className="sr-only">{t('stationSelector.label')}</span>
      <select
        id="global-station-selector"
        className="min-w-36 bg-transparent text-sm font-medium outline-none disabled:text-muted"
        value={selectedStationId}
        disabled={isLoading || stationLocked}
        onChange={(event) => setSelectedStationId(event.target.value)}
      >
        <option value="">{t('stationSelector.placeholder')}</option>
        {availableStations.map((station) => (
          <option key={station.id} value={station.id}>
            {station.name}
            {station.code ? ` · ${station.code}` : ''}
          </option>
        ))}
      </select>
    </label>
  );
};
